(function () {
  'use strict';

  /* ---- Scroll reveal (once, -100px margin, like framer-motion useInView) ---- */
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -100px 0px', threshold: 0 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- Hero video: manual fade in/out loop (no CSS transitions) ---- */
  var v = document.querySelector('[data-hero-video]');
  if (!v) return;

  var FADE_MS = 500, FADE_OUT_AT = 0.55, raf = null, fadingOut = false;

  function cur() { return parseFloat(v.style.opacity) || 0; }

  function fade(to) {
    if (raf) cancelAnimationFrame(raf);
    var from = cur(), start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / FADE_MS, 1);
      v.style.opacity = String(from + (to - from) * p);
      if (p < 1) raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);
  }

  function play() {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function onCanPlay() {
    play();
    if (!fadingOut && cur() < 1) fade(1);
  }

  v.addEventListener('canplay', onCanPlay);
  if (v.readyState >= 3) onCanPlay();

  v.addEventListener('timeupdate', function () {
    if (!fadingOut && v.duration && v.duration - v.currentTime <= FADE_OUT_AT) {
      fadingOut = true;
      fade(0);
    }
  });

  v.addEventListener('ended', function () {
    if (raf) cancelAnimationFrame(raf);
    v.style.opacity = '0';
    setTimeout(function () {
      v.currentTime = 0;
      fadingOut = false;
      play();
      fade(1);
    }, 100);
  });
})();
